import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { EMPTY_MARKER } from 'constants/product_costs_and_settings/columns'
import { getCurrencyCode, parseCurrency } from 'helpers/currency'
import { useSelectedCountry } from 'hooks/amazon_seller_account'

export const SimpleDisplayCell = ({ property, isParent, displayUnit }) => {
  const { t } = useTranslation('product_costs_and_settings')
  const { country_code } = useSelectedCountry()

  const formatText = () => {
    if (property == null || isParent) {
      return EMPTY_MARKER
    }

    if (displayUnit === 'days') {
      return `${property} ${t('product_costs_and_settings:Table.days', 'Days')}`
    }

    if (displayUnit === 'currency') {
      return parseCurrency(property, getCurrencyCode(country_code))
    }

    return property
  }

  return formatText()
}

SimpleDisplayCell.defaultProps = {
  property: undefined,
  isParent: false,
  displayUnit: 'days'
}

SimpleDisplayCell.propTypes = {
  property: PropTypes.number,
  isParent: PropTypes.bool,
  displayUnit: PropTypes.oneOf(['days', 'currency'])
}
